import { render, staticRenderFns } from "./CustomSlick.vue?vue&type=template&id=6a4e7963&"
import script from "./CustomSlick.vue?vue&type=script&lang=js&"
export * from "./CustomSlick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports